import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

function FooterTrustChat() {
  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage,
  );
  const t = useSelector(
    (state) => state.language.translations[currentLanguage],
  );

  return (
    <div className="footer__trust">
      <p className="trust__01">ⒸTrustChat {new Date().getFullYear()}</p>
      <div className="privacy__01">
        <Link onMouseEnter={(e) => {
          e.currentTarget.style.color = '#148DFD';
          e.currentTarget.style.textDecoration = 'underline';
        }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = '#556575';
            e.currentTarget.style.textDecoration = 'none';
          }} to="/privacy" style={{ textDecoration: 'none', color: '#556575', cursor: 'pointer' }}>
          <p>{t.PV_NTC}</p>
        </Link>
        <Link
          to="/subscription"
          style={{
            textDecoration: 'none',
            color: '#556575',
            cursor: 'pointer'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = '#148DFD';
            e.currentTarget.style.textDecoration = 'underline';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = '#556575';
            e.currentTarget.style.textDecoration = 'none';
          }}
        >
          {t.MSA}
        </Link>

      </div>
    </div>
  );
}

export default FooterTrustChat;
